import axios from "axios";
import { url } from "./urls";
//require("dotenv").config();

const ClienteAxios = axios.create({
  baseURL: url + "api",
});

export default ClienteAxios;
